import config from "./globalConfig";

export function authHeader(token) {
  const lang = localStorage.getItem("B2BLanguage") === "ENG" ? "en" : "it";
  if (token) {
    return {
      "X-TenantId": config.TENANT_ID,
      Authorization: "Bearer " + token,
      "Cache-Control": "no-cache",
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      "Accept-Language": lang,
    };
  } else {
    return {
      "X-TenantId": config.TENANT_ID,
      "Cache-Control": "no-cache",
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      "Accept-Language": lang,
    };
  }
}
